// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import useTranslation from "next-translate/useTranslation";

import { Form } from "@/components/core";
import { SelectOptions } from "./select-options";

const data = [
  {
    value: String.prototype.generateUUID(),
    isoCode: "TUR",
    label: "Türkiye",
  },
  {
    value: String.prototype.generateUUID(),
    isoCode: "USA",
    label: "Amerika Birleşik Devletleri",
  },
  {
    value: String.prototype.generateUUID(),
    isoCode: "GBR",
    label: "Birleşik Kırallık",
  },
];

export function SimpleCountrySelect({ name }: any) {
  const [value, setValue] = useState("");
  const [countries, setCountries] = useState([]);

  const { t } = useTranslation("common");

  useEffect(() => {
    setValue(data[0].value);
    setCountries(data);
  }, []);

  const handleChange = ({ target }: any) => {
    setValue(target.value);
  };

  const renderItem = (country: any) => <SelectOptions country={country} key={country.value} />;

  return (
    <Form.Select
      label={t("selectCountry")}
      name={name}
      options={countries}
      value={value}
      onChange={handleChange}
      renderItem={renderItem}
    />
  );
}

SimpleCountrySelect.propTypes = {
  name: PropTypes.string,
};

export function CountrySelect({ name }: any) {
  const { t } = useTranslation("common");

  const renderOption = (params: any, country: any) => (
    <SelectOptions country={country} {...params} key={country.value} />
  );
  const renderInput = (params: any) => <TextField {...params} label={t("selectCountry")} />;

  return (
    <Form.AutoComplete
      name={name}
      options={data}
      renderOption={renderOption}
      renderInput={renderInput}
    />
  );
}

CountrySelect.propTypes = {
  name: PropTypes.string,
};
